// @flow
import React from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import { closeRebateTermsModal } from '../../actions/modals'
import Button from '../../components/Button'

type Props = {
  isOpen: boolean,
  closeRebateTermsModal: Function
}

const RebateTerms = ({ isOpen, closeRebateTermsModal }: Props) => {
  // eslint-disable-line no-shadow
  if (!isOpen) return null

  return (
    <Modal
      isOpen={isOpen}
      className="modal"
      contentLabel="Rebate Terms"
      overlayClassName="modal-overlay"
      onRequestClose={closeRebateTermsModal}
    >
      <div className="modal-header">
        <h5 style={{ marginBottom: 0 }}>Rebate Terms</h5>
        <button
          type="button"
          className="modal-close"
          onClick={closeRebateTermsModal}
        >
          &times;
        </button>
      </div>
      <div className="modal-content">
        <p>
          Rebates may vary by market and are dependent on several factors
          including the price of the property and the market minimum commission.
          Kief Realty reserves the right to make changes to the rebate amount at
          any time, while honoring all agreements commenced prior to such
          change. Rebates are not available where prohibited by law. The rebate
          is subject to lender approval in some cases, and may experience
          restrictions under certain loan programs included but not limited to
          VA, FHA and USDA. Rebates are not offered on short sale transactions.
        </p>
      </div>
      <div className="modal-footer">
        <Button onClick={closeRebateTermsModal}>Ok</Button>
      </div>
    </Modal>
  )
}

export default connect(
  (state) => ({
    isOpen: state.modals.rebateTermsModalOpen
  }),
  {
    closeRebateTermsModal
  }
)(RebateTerms)



// WEBPACK FOOTER //
// ./src/components/RebateTermsModal/index.js